class View {

	/**
	 * @param {Object} options
	 */
	constructor(options) {
		options = options || {};

		if (options.el) {
			this.el = options.el;
			this.$el = this._hasJQuery() ? jQuery(options.el) : null;
		}

		this.signals = options.signals;

		if (this.initialize) {
			this.initialize(options);
		}
	}

	/**
	 * @returns {String}
	 */
	toString() {
		return '[object View]';
	}

	/**
	 *
	 * @returns {boolean}
	 * @private
	 */
	_hasJQuery() {
		return typeof jQuery !== 'undefined';
	}
}

export default View;


// WEBPACK FOOTER //
// ./js/Core/View.js